// src/client/components/CostBreakdown.tsx
import type { ReactNode } from 'react';
import type { AllInCost } from '@client/utils/loanUtils';
import { formatEAR } from '@client/utils/loanUtils';
import Money from './Money';
import styles from './CostBreakdown.module.css';

interface Props { cost: AllInCost; }

export default function CostBreakdown({ cost }: Props) {
  return (
    <dl className={styles.list}>
      <Row label="Principal" value={<Money amount={cost.principal} />} />
      <Row label="Interest" value={<Money amount={cost.interest} />} />
      <Row label="Processing fee" value={<Money amount={cost.processingFee} />} />
      <Row
        label="Total due"
        value={<strong className={styles.total}><Money amount={cost.totalDue} /></strong>}
        bold
      />
      <Row
        label="Annual rate (BoZ)"
        value={<span style={{ color: 'var(--text-muted, #6B7D93)', fontSize: 13 }}>{formatEAR(cost.ear)}</span>}
      />
    </dl>
  );
}

function Row({ label, value, bold }: { label: string; value: ReactNode; bold?: boolean }) {
  return (
    <div className={[styles.row, bold && styles.rowBold].filter(Boolean).join(' ')}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
}
